export default "__VITE_ASSET__U$BG4LVM__"